import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ICoverPage } from "src/app/models/cover-page/cover-page";

@Component({
  selector: "app-cover-pages-list",
  templateUrl: "./cover-pages-list.component.html",
  styleUrls: ["./cover-pages-list.component.scss"],
})
export class CoverPagesListComponent {
  @Input() coverPages: ICoverPage[] = [];

  @Output() editClick = new EventEmitter<ICoverPage>();
  @Output() deleteClick = new EventEmitter<ICoverPage>();
  @Output() addClick = new EventEmitter<void>();
}
